import * as React from 'react';
import { Rect, Group, Line } from 'react-konva';

export class Sprayer extends React.Component {

  state = {
    tire_height: 600,
  };


  render() {

    let center = this.props.width / 2;
    let left_center = center - this.props.track_width / 2;
    let right_center = center + this.props.track_width / 2;

    return (
      <Group
        x={this.props.x}
        y={this.props.y}
        draggable={true}
      >


        <Rect
          x={left_center - this.props.tire_width / 2}
          y={-this.state.tire_height}
          width={this.props.tire_width}
          height={this.state.tire_height}
          fill="black"
          shadowBlur={5} />

        <Rect
          x={right_center - this.props.tire_width / 2}
          y={-this.state.tire_height}
          width={this.props.tire_width}
          height={this.state.tire_height}
          fill="black"
          shadowBlur={5} />

          <Line
          points={[center, 0, center  , -1000]}
          stroke='black'
          strokeWidth={this.props.seperationLineWidth}
          dash={[50, 50]}/>

        <Rect
          x={0}
          y={0}
          width={this.props.width}
          height={this.props.boom_thickness}
          fill="grey"
          shadowBlur={5} />

      </Group>
    );
  }
}
